module.exports = __webpack_public_path__ + "static/media/logo.f4fc42aa.png";